import useAxiosService from './useAxiosService'
import { IPrescriptionDetail } from 'interfaces'
import { IMedicineMho } from 'interfaces/medicine'
import { IResponse } from 'interfaces/services'
import { IInventoryQuerySearch } from 'pages/repoInventory/interfaces'

const useMedicineService = () => {
  const { post, get } = useAxiosService()

  const searchMedicine = async (query: IInventoryQuerySearch) => {
    const response: any = await post(`/clinic/medicines/search`, query)
    return {
      ...response,
      data: response.data?.medicines || []
    } as IResponse<Array<any>>
  }

  const searchMedicineMoh = async (query: IInventoryQuerySearch) => {
    const response: any = await post(`/clinic/moh-medicines/search`, {
      offset: 0,
      limit: 10,
      order_by: '',
      asc: false,
      ...query
    })
    return {
      ...response,
      data: response.data?.moh_medicines || []
    } as IResponse<Array<IMedicineMho>>
  }

  const getPrescriptionDetail = async (bookingId: number) => {
    const response: any = await get(`/clinic/prescription/${bookingId}`)
    return response as IResponse<IPrescriptionDetail>
  }

  return { searchMedicine, searchMedicineMoh, getPrescriptionDetail }
}

export default useMedicineService
